import styled from "styled-components";
import { theme } from "styled-tools";

import mediaQuery, { Screen } from "../../Utilities/MediaQuery";

export const HeaderStyled = styled.div`
  background-color: ${theme("Neutral_900")};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 83px;
  position: relative;
  margin: 0 auto;
  width: 100%;
`;

export const Linear = styled.div`
  background: ${theme("Gradients_04")};
  height: 29px;
`;

export const Logo = styled.div`
  padding: 0 24px;

  img {
    height: 50px;
    width: 152px;

    ${mediaQuery[Screen.xs]} {
      height: 40px;
      width: 118px;
    }
  }
`;
